(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baitulia-uae-flag-day"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('baitulia-flag-day')) {
    class BaituliaFlagDay extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) this.mount();
        });
      }

      mount() {
        if (this._mounted) return;
        this._mounted = true;
        this._controller = new AbortController();
        this._surface = this.querySelector('.bfd__surface');
        this._fields = ['hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-bfd-${unit}]`));
        this._start = Date.parse(this.dataset.start);
        this._end = Date.parse(this.dataset.end);
        this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._motionButton = this.querySelector('[data-bfd-motion]');
        if (!this._surface || this._fields.some(field => !field)) return;
        if (!Number.isFinite(this._start) || !Number.isFinite(this._end) || this._end <= this._start || !/([+-]\d{2}:\d{2}|Z)$/.test(this.dataset.start) || !/([+-]\d{2}:\d{2}|Z)$/.test(this.dataset.end)) {
          this.dataset.phase = 'invalid';
          this.hidden = true;
          this.releaseSpace();
          return;
        }
        this._paused = this._reduced.matches || this.dataset.motion !== 'true';
        this.updateMotion();
        this._motionButton?.addEventListener('click', () => {
          this._paused = !this._paused;
          this.updateMotion();
        }, { signal: this._controller.signal });
        this._reduced.addEventListener('change', () => {
          this._paused = this._reduced.matches;
          this.updateMotion();
        }, { signal: this._controller.signal });
        this._resize = new ResizeObserver(() => this.measure());
        this._resize.observe(this._surface);
        document.addEventListener('visibilitychange', () => this.tick(), { signal: this._controller.signal });
        window.addEventListener('pageshow', () => this.tick(), { signal: this._controller.signal });
        this.tick();
      }

      updateMotion() {
        this.dataset.paused = String(this._paused);
        if (this._motionButton) {
          this._motionButton.setAttribute('aria-pressed', String(this._paused));
          this._motionButton.setAttribute('aria-label', this._paused ? this.dataset.labelPlay : this.dataset.labelPause);
        }
        if (this._paused || this._reduced.matches) this.querySelectorAll('strong').forEach(field => field.getAnimations().forEach(animation => animation.cancel()));
      }

      tick() {
        clearTimeout(this._timer);
        if (!this.isConnected) return;
        const now = Date.now();
        const phase = now < this._start ? 'upcoming' : now < this._end ? 'live' : 'ended';
        const target = phase === 'upcoming' ? this._start : this._end;
        const seconds = Math.max(0, Math.ceil((target - now) / 1000));
        const values = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        this._fields.forEach((field, index) => {
          const next = String(values[index]).padStart(2, '0');
          if (field.textContent === next) return;
          field.textContent = next;
          if (this._previousPhase && !this._paused && !this._reduced.matches && !document.hidden && field.animate) {
            field.getAnimations().forEach(animation => animation.cancel());
            field.animate([{ transform: 'translateY(3px)', opacity: 0.6 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 220, easing: 'cubic-bezier(.16,1,.3,1)' });
          }
        });
        this.dataset.phase = phase;
        if (phase !== this._previousPhase) {
          const label = phase === 'upcoming' ? this.dataset.labelUpcoming : phase === 'live' ? this.dataset.labelLive : this.dataset.labelEnded;
          this.querySelector('[data-bfd-label]').textContent = label;
          this.querySelector('[data-bfd-cta]').textContent = phase === 'upcoming' ? this.dataset.ctaUpcoming : this.dataset.ctaLive;
          if (this._previousPhase) this.querySelector('[data-bfd-status]').textContent = label;
          this._previousPhase = phase;
        }
        const visible = phase !== 'ended' || this.dataset.designMode === 'true';
        this.hidden = !visible;
        if (visible) {
          document.documentElement.classList.add('bfd-event-visible');
          document.documentElement.classList.toggle('bfd-hide-original', this.dataset.hideOriginal === 'true');
          this.measure();
        } else {
          this.releaseSpace();
        }
        if (phase !== 'ended') this._timer = setTimeout(() => this.tick(), 1000 - Date.now() % 1000 + 15);
      }

      measure() {
        if (this.hidden || !this._surface) return;
        const height = `${Math.ceil(this._surface.getBoundingClientRect().height)}px`;
        if (this.style.getPropertyValue('--bfd-reserved') !== height) this.style.setProperty('--bfd-reserved', height);
        if (document.documentElement.style.getPropertyValue('--bfd-height') !== height) document.documentElement.style.setProperty('--bfd-height', height);
      }

      releaseSpace() {
        if (Array.from(document.querySelectorAll('baitulia-flag-day')).some(element => element !== this && !element.hidden && element.isConnected)) return;
        document.documentElement.classList.remove('bfd-event-visible', 'bfd-hide-original');
        document.documentElement.style.removeProperty('--bfd-height');
      }

      disconnectedCallback() {
        clearTimeout(this._timer);
        this._resize?.disconnect();
        this._controller?.abort();
        this._mounted = false;
        this.releaseSpace();
      }
    }
    customElements.define('baitulia-flag-day', BaituliaFlagDay);
  }

  } catch(e) { console.error(e); }
})();
})();
